import { useState } from "react";

interface InsurerModalState {
	isOpen: boolean;
	participantId: number | null;
	constructionSiteId: number | null;
	currentInsurer: {
		id: number;
		denomination: string;
	} | null;
}

export const useInsurerModal = () => {
	const [modalState, setModalState] = useState<InsurerModalState>({
		isOpen: false,
		participantId: null,
		constructionSiteId: null,
		currentInsurer: null,
	});

	const closeModal = () => {
		setModalState({
			isOpen: false,
			participantId: null,
			constructionSiteId: null,
			currentInsurer: null,
		});
	};

	return {
		modalState,
		setModalState,
		closeModal,
	};
};
